export const firstNameFrom = (fullName) => {
  const words = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0];
  return words[words.length - 2];
};

export const fillNoticeText = (text, name) => {
  if (text == null) return '';
  return String(text).replaceAll('{name}', name || '');
};
